import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../src/common/SafeIcon';

const { FiAlertTriangle, FiShield, FiHelpCircle } = FiIcons;

export const Problem: React.FC = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-serif font-bold text-slate-900 mb-6">Why This Course Exists</h2>
            <h3 className="text-xl text-brand-900 font-semibold mb-6">Clients are asking about Bitcoin and digital assets—whether firms are ready or not.</h3>
            <p className="text-lg text-slate-600 mb-8">Many advisors feel stuck in the middle. They want to be helpful, but they don’t want to speculate, and they can’t always recommend crypto products—even ETFs.</p>
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                  <SafeIcon icon={FiHelpCircle} className="w-5 h-5 text-slate-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-900">The Knowledge Gap</h4>
                  <p className="text-slate-600">Digital Assets Literacy closes the knowledge gap so you can stay calm and credible.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                  <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 text-slate-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-900">Protect Client Trust</h4>
                  <p className="text-slate-600">Stay compliant while protecting client trust through objective, fiduciary-aligned guidance.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl bg-white border border-slate-200 p-2">
              <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1600&q=80" alt="Financial advisor meeting" className="w-full h-full object-cover rounded-xl" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-brand-900 p-6 rounded-xl shadow-xl max-w-xs hidden md:block text-white">
              <p className="font-serif text-lg italic text-brand-50 mb-4">"Finally, a way to talk about crypto that feels professional and safe."</p>
              <div className="flex items-center gap-2 opacity-80">
                <div className="h-0.5 w-8 bg-accent-500"></div>
                <p className="text-xs font-bold uppercase tracking-wider">Advisor Feedback</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};